module.exports = __webpack_public_path__ + "static/img/app-text-bg@w.305ff1c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/glovis-aa/app-text-bg@w.png
// module id = +FHh
// module chunks = 0